import type { Vec2 } from '@/types'

export function vec2(x: number, y: number): Vec2 {
    return { x, y }
}

export function add(a: Vec2, b: Vec2): Vec2 {
    return { x: a.x + b.x, y: a.y + b.y }
}

export function sub(a: Vec2, b: Vec2): Vec2 {
    return { x: a.x - b.x, y: a.y - b.y }
}

export function scale(v: Vec2, s: number): Vec2 {
    return { x: v.x * s, y: v.y * s }
}

export function length(v: Vec2): number {
    return Math.sqrt(v.x * v.x + v.y * v.y)
}

export function distance(a: Vec2, b: Vec2): number {
    return length(sub(a, b))
}

export function normalize(v: Vec2): Vec2 {
    const len = length(v)
    if (len === 0) return { x: 0, y: 0 }
    return { x: v.x / len, y: v.y / len }
}

export function copy(v: Vec2): Vec2 {
    return { x: v.x, y: v.y }
}
